import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ShownRightService {
  htmlShownRight: EventEmitter<any> = new EventEmitter();

  initialHtmlShownRight: any;

  get getInitialShownRight(): any {
    return this.initialHtmlShownRight;
  }

  addShownRight(component: any){
    this.initialHtmlShownRight = component;
    this.htmlShownRight.emit(component);
  }
}
